import { Component, ComponentFactoryResolver, ComponentRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Task } from '../../../models/task';
import { SynchronizationService } from '../../../services/synchronization.service';
import { DynamicElementService } from '../../../services/dynamicElement.service';
import { InteractionService } from '../../../services/interaction.service';
import { HTMLElementPositioningHelper } from '../../../util/htmlelement-positioning-helper';
import { StickerDetailComponent } from '../../sticker-detail/sticker-detail.component';
import { KanbanBoardViewComponent } from '../../../actionviews/kanban-board-view/kanban-board-view.component';

@Component({
  selector: 'app-kanban-taskcard',
  templateUrl: './taskcard.component.html',
  styleUrls: ['./taskcard.component.scss']
  })
export class KanbanTaskcardComponent implements OnInit {
  @Input() public task: Task;
  @Input() public kanbanBoardViewComponent: KanbanBoardViewComponent;
  @ViewChild('popupInsertionPoint', { read: ViewContainerRef }) popupInsertionPoint: ViewContainerRef;
  private dynamicElementInsertionPoint: ViewContainerRef;

  constructor(
    private resolver: ComponentFactoryResolver,
    private interactionService: InteractionService,
    private syncService: SynchronizationService,
    private dynamicElementService: DynamicElementService,
    private positionHelper: HTMLElementPositioningHelper,
  ) { }

  ngOnInit() {
    this.dynamicElementInsertionPoint = this.dynamicElementService.getInsertionPoint();
  }

  public onStickerClicked(event: MouseEvent, task, sticker) {
    // Create a new card and open it at the correct position
    const card: StickerDetailComponent = this.kanbanBoardViewComponent.dynamicallyAddStickerCardComponent(task, sticker, null);
    this.positionHelper.setAbsolutePosition(card.getElementRef().nativeElement, event.clientX, event.clientY);
  }

}
